import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { NotificationModel } from '../entities/notification.model';
import { RestResponse } from '../entities/rest.response.model';
import { ApiService } from './api.service';
import API from '../../common/services/api.config.json';
import { ResponseStatus } from '../enums/common-enums';
import { SharedService } from './shared-service';
import  data from '../../../../app/config.json';
import { Usuario } from '../types/usuario.type';
import { UsuarioComponent } from 'app/modules/employee-view/common/usuario/usuario.component';
import Utils from 'app/Utils';
@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    private hubConnection: signalR.HubConnection;

    public isNotificationsLoading = false;
    public count = 0;
    public list = new Array<NotificationModel>();

    constructor(
        private apiService: ApiService,
        private sharedService: SharedService,
    ) { }

    public startConnection = () => {

        const user = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser')));

        if (!this.hubConnection && user) {

            this.refreshNotificationCount();
            const endpoint = `${localStorage.getItem('baseURL')}notification?userId=${user.usuarioId}`;

            this.hubConnection = new signalR.HubConnectionBuilder()
                .configureLogging(signalR.LogLevel.Debug)
                .withUrl(endpoint, {
                    transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling
                })
                .withAutomaticReconnect()
                .build();

            this.hubConnection
                .start()
                .then(() =>
                    this.hubConnection.invoke('InitConnection').then(function (connectionId) {
                        console.log(connectionId);
                    }))
                .catch(err => console.error(err));

            this.hubConnection.on('broadcasted', (data) => {
                console.log(data);
            });

            this.hubConnection.on('notified', (data) => {
                this.refreshNotificationCount();
            });

            this.hubConnection.on('errorOccurred', (data) => {
                console.error(
                    "Background process failed" + (data.errorSource != null ? ` in ${data.errorSource}` : "") +
                    `\nError : ${data.error}`
                );
                this.sharedService.ShowSnackBar("Lo siento, la generación del informe del estudio ha fallado.");
            });
        }
    };

    // Will be used in the future
    private downloadLastNotificationFile() {
        this.getNotificationList(true).subscribe(res => {
            if (res.code === ResponseStatus.Success) {
                this.list = res.result;
                if (this.list.length > 0) {
                    const lastNotification = this.list[this.list.length - 1];
                    if (lastNotification.isDownloadable) {
                        this.sharedService.ShowSnackBar("Descargar el documento de los estudios");
                        this.downloadNotificationFile(lastNotification.id);
                    }
                }
            } else {
                this.sharedService.ShowSnackBar("Lo sentimos, la descarga del documento de los estudios ha fallado");
                console.error(res.message);
            }
        }, error => {
            this.sharedService.ShowSnackBar("Lo sentimos, la descarga del documento de los estudios ha fallado");
            console.error(error);
        });
    }

    public refreshNotificationCount(onlyNew = true): void {
        this.getNotificationCount(onlyNew).subscribe(res => {
            if (res.code === ResponseStatus.Success) {
                this.count = res.result;
            } else {
                console.error(res.message);
            }
        });
    }

    public refreshNotificationList(onlyNew = false): void {
        this.isNotificationsLoading = true;
        this.getNotificationList(onlyNew).subscribe(res => {
            if (res.code === ResponseStatus.Success) {
                this.list = res.result;
            } else {
                console.error(res.message);
            }
            this.isNotificationsLoading = false;
        }, error => {
            this.isNotificationsLoading = false;
            console.error(error);
        });
    }

    private getNotificationCount(onlyNew: boolean): Observable<RestResponse> {
        const url = `${API.Notifications.getNotificationCount}?onlyNew=${onlyNew}`;
        return this.apiService.get(url);
    }

    public getNotificationList(onlyNew: boolean): Observable<RestResponse> {
        const url = `${API.Notifications.getNotificationList}?onlyNew=${onlyNew}`;
        return this.apiService.get(url);
    }

    private checkNotification(id: number): Observable<RestResponse> {
        let url = `${API.Notifications.checkNotification}`;
        url = url.replace('{id}', String(id));
        return this.apiService.put(url, id);
    }

    private downloadFile(id: number): Observable<RestResponse> {
        const url = `${API.Notifications.downloadFile}?id=${id}`;
        return this.apiService.get(url);
    }

    public downloadNotificationFile(id: number): void {
        this.downloadFile(id).subscribe(res => {
            if (res.code === ResponseStatus.Success) {
                this.DownloadFile(res.result.file, res.result.fileName);
            }
        });
    }

    public checkedNotification(id: number): void {
        this.checkNotification(id).subscribe(res => {
            if (res.code === ResponseStatus.Success) {
                this.refreshNotificationCount();
            }
        }, error => {
            console.error(error);
        });
    }

    public DownloadFile(file: any, fileName: string): void {
        const link = document.createElement('a');
        link.setAttribute('type', 'hidden');
        link.href = 'data:application/octet-stream;base64,' + file;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}
